module.exports = __webpack_public_path__ + "img/amazon_small.d09fe8f1.png";